import { Link as LinkToExtend } from '@tiptap/extension-link';

export const Link = LinkToExtend.extend({
        addAttributes() {
            return {
                ...this.parent?.(),
                class: {
                    default: 'color-link cursor-pointer'
                },
                style: {
                    default: null
                }
            };
        }
    }
);
